/**
 * @file コンポーネント：モーダル スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledModal = styled.div`
    display: none;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${zIndex.modal};
    width: 100%;
    height: 100%;
    padding: 8px 0;
    background-color: rgba(0, 0, 0, 0.5);

    &.is-opaque {
        background-color: #000000;
    }

    &.is-show {
        display: flex;
    }
`;

export const StyledModalContainer = styled.div`
    position: relative;
    max-height: 100%;
    margin: auto;
    padding: 24px;
    overflow-y: auto;
    border-radius: 4px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    cursor: default;

    ${mediaQuery.sp(`
        width: 344px;
    `)};

    ${mediaQuery.spWide(`
        width: 448px;
    `)};

    ${mediaQuery.tablet(`
        width: 712px;
    `)};

    ${mediaQuery.pc(`
        width: 712px;
    `)};

    ${mediaQuery.pcWide(`
        width: 712px;
    `)};
`;

export const StyledModalContainerButton = styled.a`
    display: block;
    min-width: 88px;
    padding: 6px 8px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 24px;
    text-align: center;

    &[data-button-type="cancel"] {
        color: #25292d;
    }

    &[data-button-type="caution"] {
        background-color: #c31a1e;
        color: #ffffff;
    }

    &[data-button-type="submit"] {
        background-color: #061c72;
        color: #ffffff;
    }

    &.is-disabled {
        background-color: #d7d7d7;
        color: #868686;
        pointer-events: none;
    }
`;

export const StyledModalContainerButtonlist = styled.ul`
    display: flex;
    justify-content: flex-end;
`;

export const StyledModalContainerButtonlistItem = styled.li`
    margin-right: 4px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledModalContainerClose = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    border: none;
    background-color: transparent;
    color: #000000;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
`;

export const StyledModalContainerContent = styled.div`
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledModalContainerHeadline = styled.h2`
    margin-bottom: 24px;
    color: #212121;
    font-weight: normal;
    font-size: 20px;
    line-height: 28px;
`;
